import { AuthError } from '@azure/msal-browser';

interface MsalErrorDetails {
  readonly errorCode: string;
  readonly errorMessage?: string;
  readonly subError?: string;
}

type GetMsalErrorDetails = (error: unknown) => MsalErrorDetails;
export const getMsalErrorDetails: GetMsalErrorDetails = (error) => {
  if (error instanceof AuthError) {
    return {
      errorCode: error.errorCode,
      errorMessage: error.errorMessage,
      subError: error.subError,
    };
  }

  if (error instanceof Error) {
    return {
      errorCode: 'unknown',
      errorMessage: error.message,
    };
  }

  return {
    errorCode: 'unknown',
  };
};
